const doc = [({"ja":({"adminComponentHotelFilter":({"hotelFilterTitle":"フィルタ設定", "addFilter":"フィルタの追加"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;